import { Avatar, AppBar, Toolbar, Typography } from '@material-ui/core';
import { Theme, makeStyles } from '@material-ui/core/styles';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { ITopMenuProps, TopMenu } from '../TopMenu';
import React from 'react';
import { SettingsMenu, ISettingsMenuProps } from '../SettingsMenu';
import clsx from 'clsx';
import { NavBarDivider, NavBarDividerProps } from './NavBarDivider';
import { printStyles } from '../../styles/printStyles';
import { LogoImage, LogoProps } from './LogoImage';

export const NavBar = (props: INavBarProps): JSX.Element => {
    const { userName, classes: customClasses, additionalTopMenuItems, additionalSettingsMenuItems, beforeSettingsMenuArea, afterSettingsMenuArea } = props;

    const classes = useStyles();

    return (
        <AppBar className={clsx(classes.appBar, classes.hideForPrint)} position={'fixed'}>
            <Toolbar disableGutters={true}>
                <LogoImage {...props} />
                <div className={classes.grow} />
                {beforeSettingsMenuArea}
                <SettingsMenu {...props}>{additionalSettingsMenuItems}</SettingsMenu>
                <NavBarDivider classes={customClasses} />
                {afterSettingsMenuArea && (
                    <React.Fragment>
                        {afterSettingsMenuArea} <NavBarDivider classes={customClasses} />
                    </React.Fragment>
                )}
                <Avatar className={classes.avatar}>
                    <AccountCircleIcon className={classes.icon} />
                </Avatar>
                <Typography color="inherit" noWrap={true}>
                    <UserName userName={userName} />
                </Typography>
                <TopMenu {...props}>{additionalTopMenuItems}</TopMenu>
            </Toolbar>
        </AppBar>
    );
};

const UserName = (props: { userName: string }): JSX.Element => <React.Fragment>{props.userName ? props.userName : ''}</React.Fragment>;

interface IOwnProps {
    userName: string;
    additionalTopMenuItems?: JSX.Element | JSX.Element[];
    additionalSettingsMenuItems?: JSX.Element | JSX.Element[];
    beforeSettingsMenuArea?: JSX.Element;
    afterSettingsMenuArea?: JSX.Element;
}

export type INavBarProps = IOwnProps & ISettingsMenuProps & ITopMenuProps & NavBarDividerProps & LogoProps;

const useStyles = makeStyles((theme: Theme) => {
    return {
        ...printStyles,
        appBar: {
            zIndex: theme.zIndex.drawer + 1
        },
        icon: {
            color: theme.palette.common.white
        },
        avatar: {
            backgroundColor: 'inherit',
            marginRight: '1rem'
        },
        grow: {
            flexGrow: 1
        }
    };
});
